import "./help.css";

export function HelpButton({ onOpen }: { onOpen: () => void }) {
  return <button type="button" className="help-menu-button" aria-label="Помощь" title="Помощь" onClick={onOpen}>
    <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M9.5 8.5a2.5 2.5 0 0 1 5 0c0 2-2.5 2-2.5 4.5m0 3v.2" /></svg>
  </button>;
}
